// language=GraphQL
export const ALL_PRICING_RULES_QUERY = `query Query($withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAccommodationAddonsMandatorySettingsBusSettings: Boolean = false, $withAgeGroups: Boolean = false, $withAgeFilter: Boolean = false, $withTravelDates: Boolean = false, $withTravelDatesAvailabilityStatus: Boolean = false, $withTravelDatesAvailabilityStatusTenantSettings: Boolean = false, $withTravelDatesExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateExtension: Boolean = false, $withTravelDatesExtensionBaseDatePackageSettings: Boolean = false, $withTravelDatesExtensionBaseDateExtensions: Boolean = false, $withTravelDatesExtension: Boolean = false, $withTravelDatesExtensionTravelExtension: Boolean = false, $withTravelDatesExtensionAccommodationMapItems: Boolean = false, $withTravelDatesPackageSettings: Boolean = false, $withTravelDatesExtensions: Boolean = false, $withTravelDatesExtensionsTravelExtension: Boolean = false, $withTravelDatesExtensionsAccommodationMapItems: Boolean = false) {
  pricingRules: allTravelPricingRules {
    id
    checkAccommodationTypes
    accommodations @include(if: $withAccommodations) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withAccommodationsCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAccommodationsAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
    familyPackages @include(if: $withFamilyPackages) {
      id
      ratioServiceNo
      accommodation @include(if: $withFamilyPackagesAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withFamilyPackagesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      name
      label
      info
      capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withFamilyPackagesAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
    checkAccommodationAddons
    accommodationAddons @include(if: $withAccommodationAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withAccommodationAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withAccommodationAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
    checkAgeGroups
    ageGroups @include(if: $withAgeGroups) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    useAgeFilter
    ageFilter @include(if: $withAgeFilter) {
      id
      minAge
      maxAge
    }
    checkDateRange
    startDate
    endDate
    checkTravelDate
    travelDates @include(if: $withTravelDates) {
      id
      dateNo
      startDate
      endDate
      availabilityStatus @include(if: $withTravelDatesAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withTravelDatesAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      isHidden
      includesExtension
      extensionBaseDate @include(if: $withTravelDatesExtensionBaseDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withTravelDatesExtensionBaseDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        isHidden
        includesExtension
        extensionBaseDate @include(if: $withTravelDatesExtensionBaseDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
        extension @include(if: $withTravelDatesExtensionBaseDateExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withTravelDatesExtensionBaseDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withTravelDatesExtensionBaseDateExtensions) {
          id
          label
          info
        }
      }
      extension @include(if: $withTravelDatesExtension) {
        id
        label
        info
        travelExtension @include(if: $withTravelDatesExtensionTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravelDatesExtensionAccommodationMapItems) {
          id
        }
      }
      packageSettings @include(if: $withTravelDatesPackageSettings) {
        id
        ratioPackageNo
        price
        availabilityStatus
      }
      json
      extensions @include(if: $withTravelDatesExtensions) {
        id
        label
        info
        travelExtension @include(if: $withTravelDatesExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravelDatesExtensionsAccommodationMapItems) {
          id
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_PRICING_RULES_QUERY = `query Query($id: ID!, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAccommodationAddonsMandatorySettingsBusSettings: Boolean = false, $withAgeGroups: Boolean = false, $withAgeFilter: Boolean = false, $withTravelDates: Boolean = false, $withTravelDatesAvailabilityStatus: Boolean = false, $withTravelDatesAvailabilityStatusTenantSettings: Boolean = false, $withTravelDatesExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateExtension: Boolean = false, $withTravelDatesExtensionBaseDatePackageSettings: Boolean = false, $withTravelDatesExtensionBaseDateExtensions: Boolean = false, $withTravelDatesExtension: Boolean = false, $withTravelDatesExtensionTravelExtension: Boolean = false, $withTravelDatesExtensionAccommodationMapItems: Boolean = false, $withTravelDatesPackageSettings: Boolean = false, $withTravelDatesExtensions: Boolean = false, $withTravelDatesExtensionsTravelExtension: Boolean = false, $withTravelDatesExtensionsAccommodationMapItems: Boolean = false) {
  pricingRules: travelPricingRules(id: $id) {
    id
    checkAccommodationTypes
    accommodations @include(if: $withAccommodations) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withAccommodationsCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAccommodationsAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
    familyPackages @include(if: $withFamilyPackages) {
      id
      ratioServiceNo
      accommodation @include(if: $withFamilyPackagesAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withFamilyPackagesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      name
      label
      info
      capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withFamilyPackagesAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
    checkAccommodationAddons
    accommodationAddons @include(if: $withAccommodationAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withAccommodationAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withAccommodationAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
    checkAgeGroups
    ageGroups @include(if: $withAgeGroups) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    useAgeFilter
    ageFilter @include(if: $withAgeFilter) {
      id
      minAge
      maxAge
    }
    checkDateRange
    startDate
    endDate
    checkTravelDate
    travelDates @include(if: $withTravelDates) {
      id
      dateNo
      startDate
      endDate
      availabilityStatus @include(if: $withTravelDatesAvailabilityStatus) {
        id
        label
        status
        isDefaultStatus
        isDefaultWaitlistFallback
        tenantSettings @include(if: $withTravelDatesAvailabilityStatusTenantSettings) {
          id
          label
          info
          switchToStatusInfo
          submitButtonLabel
        }
      }
      isHidden
      includesExtension
      extensionBaseDate @include(if: $withTravelDatesExtensionBaseDate) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withTravelDatesExtensionBaseDateAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        isHidden
        includesExtension
        extensionBaseDate @include(if: $withTravelDatesExtensionBaseDateExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
        extension @include(if: $withTravelDatesExtensionBaseDateExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withTravelDatesExtensionBaseDatePackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withTravelDatesExtensionBaseDateExtensions) {
          id
          label
          info
        }
      }
      extension @include(if: $withTravelDatesExtension) {
        id
        label
        info
        travelExtension @include(if: $withTravelDatesExtensionTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravelDatesExtensionAccommodationMapItems) {
          id
        }
      }
      packageSettings @include(if: $withTravelDatesPackageSettings) {
        id
        ratioPackageNo
        price
        availabilityStatus
      }
      json
      extensions @include(if: $withTravelDatesExtensions) {
        id
        label
        info
        travelExtension @include(if: $withTravelDatesExtensionsTravelExtension) {
          id
          duration
          name
          description
        }
        accommodationMapItems @include(if: $withTravelDatesExtensionsAccommodationMapItems) {
          id
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_PRICING_RULES_MUTATION = `
  mutation Mutation($input: CreateTravelPricingRulesInput, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAccommodationAddonsMandatorySettingsBusSettings: Boolean = false, $withAgeGroups: Boolean = false, $withAgeFilter: Boolean = false, $withTravelDates: Boolean = false, $withTravelDatesAvailabilityStatus: Boolean = false, $withTravelDatesAvailabilityStatusTenantSettings: Boolean = false, $withTravelDatesExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateExtension: Boolean = false, $withTravelDatesExtensionBaseDatePackageSettings: Boolean = false, $withTravelDatesExtensionBaseDateExtensions: Boolean = false, $withTravelDatesExtension: Boolean = false, $withTravelDatesExtensionTravelExtension: Boolean = false, $withTravelDatesExtensionAccommodationMapItems: Boolean = false, $withTravelDatesPackageSettings: Boolean = false, $withTravelDatesExtensions: Boolean = false, $withTravelDatesExtensionsTravelExtension: Boolean = false, $withTravelDatesExtensionsAccommodationMapItems: Boolean = false) {
    pricingRules: createTravelPricingRules(input: $input) {
      id
      checkAccommodationTypes
      accommodations @include(if: $withAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
      familyPackages @include(if: $withFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withFamilyPackagesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        name
        label
        info
        capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
      checkAccommodationAddons
      accommodationAddons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withAccommodationAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withAccommodationAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
      checkAgeGroups
      ageGroups @include(if: $withAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      useAgeFilter
      ageFilter @include(if: $withAgeFilter) {
        id
        minAge
        maxAge
      }
      checkDateRange
      startDate
      endDate
      checkTravelDate
      travelDates @include(if: $withTravelDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withTravelDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withTravelDatesAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        isHidden
        includesExtension
        extensionBaseDate @include(if: $withTravelDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withTravelDatesExtensionBaseDateAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          isHidden
          includesExtension
          extensionBaseDate @include(if: $withTravelDatesExtensionBaseDateExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
          extension @include(if: $withTravelDatesExtensionBaseDateExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withTravelDatesExtensionBaseDatePackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withTravelDatesExtensionBaseDateExtensions) {
            id
            label
            info
          }
        }
        extension @include(if: $withTravelDatesExtension) {
          id
          label
          info
          travelExtension @include(if: $withTravelDatesExtensionTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravelDatesExtensionAccommodationMapItems) {
            id
          }
        }
        packageSettings @include(if: $withTravelDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withTravelDatesExtensions) {
          id
          label
          info
          travelExtension @include(if: $withTravelDatesExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravelDatesExtensionsAccommodationMapItems) {
            id
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_PRICING_RULES_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingRulesInput, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAccommodationAddonsMandatorySettingsBusSettings: Boolean = false, $withAgeGroups: Boolean = false, $withAgeFilter: Boolean = false, $withTravelDates: Boolean = false, $withTravelDatesAvailabilityStatus: Boolean = false, $withTravelDatesAvailabilityStatusTenantSettings: Boolean = false, $withTravelDatesExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateExtension: Boolean = false, $withTravelDatesExtensionBaseDatePackageSettings: Boolean = false, $withTravelDatesExtensionBaseDateExtensions: Boolean = false, $withTravelDatesExtension: Boolean = false, $withTravelDatesExtensionTravelExtension: Boolean = false, $withTravelDatesExtensionAccommodationMapItems: Boolean = false, $withTravelDatesPackageSettings: Boolean = false, $withTravelDatesExtensions: Boolean = false, $withTravelDatesExtensionsTravelExtension: Boolean = false, $withTravelDatesExtensionsAccommodationMapItems: Boolean = false) {
    pricingRules: updateTravelPricingRules(input: $input) {
      id
      checkAccommodationTypes
      accommodations @include(if: $withAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
      familyPackages @include(if: $withFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withFamilyPackagesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        name
        label
        info
        capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
      checkAccommodationAddons
      accommodationAddons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withAccommodationAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withAccommodationAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
      checkAgeGroups
      ageGroups @include(if: $withAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      useAgeFilter
      ageFilter @include(if: $withAgeFilter) {
        id
        minAge
        maxAge
      }
      checkDateRange
      startDate
      endDate
      checkTravelDate
      travelDates @include(if: $withTravelDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withTravelDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
          tenantSettings @include(if: $withTravelDatesAvailabilityStatusTenantSettings) {
            id
            label
            info
            switchToStatusInfo
            submitButtonLabel
          }
        }
        isHidden
        includesExtension
        extensionBaseDate @include(if: $withTravelDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withTravelDatesExtensionBaseDateAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          isHidden
          includesExtension
          extensionBaseDate @include(if: $withTravelDatesExtensionBaseDateExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
          extension @include(if: $withTravelDatesExtensionBaseDateExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withTravelDatesExtensionBaseDatePackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withTravelDatesExtensionBaseDateExtensions) {
            id
            label
            info
          }
        }
        extension @include(if: $withTravelDatesExtension) {
          id
          label
          info
          travelExtension @include(if: $withTravelDatesExtensionTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravelDatesExtensionAccommodationMapItems) {
            id
          }
        }
        packageSettings @include(if: $withTravelDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withTravelDatesExtensions) {
          id
          label
          info
          travelExtension @include(if: $withTravelDatesExtensionsTravelExtension) {
            id
            duration
            name
            description
          }
          accommodationMapItems @include(if: $withTravelDatesExtensionsAccommodationMapItems) {
            id
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_PRICING_RULES_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingRulesInput) {
    deleteTravelPricingRules(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PRICING_RULES_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingRulesInput) {
    forceDeleteTravelPricingRules(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_PRICING_RULES_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: addTravelPricingRulesAccommodationsInput) {
    addTravelPricingRulesAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const REMOVE_PRICING_RULES_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: removeTravelPricingRulesAccommodationsInput) {
    removeTravelPricingRulesAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const CREATE_PRICING_RULES_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: createTravelPricingRulesAccommodationsInput) {
    createTravelPricingRulesAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const DELETE_PRICING_RULES_ACCOMMODATIONS_MUTATION = `
  mutation Mutation($input: deleteTravelPricingRulesAccommodationsInput) {
    deleteTravelPricingRulesAccommodations(input: $input) {
      id
      accommodationIds
    }
  }`

// language=GraphQL
export const ADD_PRICING_RULES_FAMILY_PACKAGES_MUTATION = `
  mutation Mutation($input: addTravelPricingRulesFamilyPackagesInput) {
    addTravelPricingRulesFamilyPackages(input: $input) {
      id
      familyPackageIds
    }
  }`

// language=GraphQL
export const REMOVE_PRICING_RULES_FAMILY_PACKAGES_MUTATION = `
  mutation Mutation($input: removeTravelPricingRulesFamilyPackagesInput) {
    removeTravelPricingRulesFamilyPackages(input: $input) {
      id
      familyPackageIds
    }
  }`

// language=GraphQL
export const CREATE_PRICING_RULES_FAMILY_PACKAGES_MUTATION = `
  mutation Mutation($input: createTravelPricingRulesFamilyPackagesInput) {
    createTravelPricingRulesFamilyPackages(input: $input) {
      id
      familyPackageIds
    }
  }`

// language=GraphQL
export const DELETE_PRICING_RULES_FAMILY_PACKAGES_MUTATION = `
  mutation Mutation($input: deleteTravelPricingRulesFamilyPackagesInput) {
    deleteTravelPricingRulesFamilyPackages(input: $input) {
      id
      familyPackageIds
    }
  }`

// language=GraphQL
export const ADD_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: addTravelPricingRulesAccommodationAddonsInput) {
    addTravelPricingRulesAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const REMOVE_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: removeTravelPricingRulesAccommodationAddonsInput) {
    removeTravelPricingRulesAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const CREATE_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: createTravelPricingRulesAccommodationAddonsInput) {
    createTravelPricingRulesAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const DELETE_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION = `
  mutation Mutation($input: deleteTravelPricingRulesAccommodationAddonsInput) {
    deleteTravelPricingRulesAccommodationAddons(input: $input) {
      id
      accommodationAddonIds
    }
  }`

// language=GraphQL
export const ADD_PRICING_RULES_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: addTravelPricingRulesAgeGroupsInput) {
    addTravelPricingRulesAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const REMOVE_PRICING_RULES_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: removeTravelPricingRulesAgeGroupsInput) {
    removeTravelPricingRulesAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const CREATE_PRICING_RULES_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: createTravelPricingRulesAgeGroupsInput) {
    createTravelPricingRulesAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const DELETE_PRICING_RULES_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: deleteTravelPricingRulesAgeGroupsInput) {
    deleteTravelPricingRulesAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const ADD_PRICING_RULES_TRAVEL_DATES_MUTATION = `
  mutation Mutation($input: addTravelPricingRulesTravelDatesInput) {
    addTravelPricingRulesTravelDates(input: $input) {
      id
      travelDateIds
    }
  }`

// language=GraphQL
export const REMOVE_PRICING_RULES_TRAVEL_DATES_MUTATION = `
  mutation Mutation($input: removeTravelPricingRulesTravelDatesInput) {
    removeTravelPricingRulesTravelDates(input: $input) {
      id
      travelDateIds
    }
  }`

// language=GraphQL
export const CREATE_PRICING_RULES_TRAVEL_DATES_MUTATION = `
  mutation Mutation($input: createTravelPricingRulesTravelDatesInput) {
    createTravelPricingRulesTravelDates(input: $input) {
      id
      travelDateIds
    }
  }`

// language=GraphQL
export const DELETE_PRICING_RULES_TRAVEL_DATES_MUTATION = `
  mutation Mutation($input: deleteTravelPricingRulesTravelDatesInput) {
    deleteTravelPricingRulesTravelDates(input: $input) {
      id
      travelDateIds
    }
  }`

// language=GraphQL
export const UPDATE_PRICING_RULES_TRAVEL_DATES_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelPricingRulesTravelDatesOrderInput) {
    updateTravelPricingRulesTravelDatesOrder(input: $input) {
      id
      travelDateIds
    }
  }`

// language=GraphQL
export const PRICING_RULES_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricingMandatorySettings: Boolean = false) {
  groupedDependents: travelPricingRulesDependents(id: $id) {
    travelPricingMandatorySettings @include(if: $withTravelPricingMandatorySettings) {
      id
      isMandatory
      useRules
      useDateSwitch
      useBusSettings
    }
  }
}`
